module.exports = __webpack_public_path__ + "static/media/atmende-buecher.8a1c1919.jpg";